import styled from 'styled-components'

export const $Description = styled.p`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.text.headLine};
`
